import { useEffect } from 'react';
import { Section, CTA } from 'react-scale/components';
import cn from 'classnames';

import s from './spin-banner.module.css';

const SpinBanner = () => {
  useEffect(() => {
    document.documentElement.style.setProperty('scroll-behavior', 'smooth');

    return () => {
      document.documentElement.style.removeProperty('scroll-behaviour');
    };
  }, []);

  return (
    <Section>
      <div>
        <div className={s['spin-wrapper']}>
          <p className="text-gradient">Extract any field from</p>

          <div className="h-12 mt-1 lg:h-20 md:h-14 md:mt-3 xl:mt-0">
            <div className={s.cubespinner}>
              <div className={s.face1}>packing lists</div>
              <div className={s.face2}>commercial invoices</div>
              <div className={s.face3}>bills of lading</div>
              <div className={cn('whitespace-nowrap', s.face4)}>mortgage applications</div>
              <div className={s.face5}>insurance cards</div>
              <div className={s.face6}>arrival notices</div>
            </div>
          </div>

          <p className="text-gradient">at 99%+ accuracy</p>
        </div>
      </div>

      <div className={s.cta}>
        <CTA
          cta={{
            buttons: [
              {
                href: '#how-it-works',
                type: 'primary',
                text: 'Learn More'
              }
            ]
          }}
        />
      </div>
    </Section>
  );
};

export default SpinBanner;
